// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb724cda","239":"99bae34d","453":"fef45859","455":"1916e473"}[chunkId] + ".chunk.js";
};